import React, { useMemo } from "react";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import PolygonUp from "../../../shared/assets/icons/PolygonUp";
import PolygonDown from "../../../shared/assets/icons/PolygonDown";
import Users from "../../../shared/assets/icons/Users";
import VendorIcon from "../../../shared/assets/icons/VendorIcon";
import IpIcon from "../../../shared/assets/icons/IpIcon";

const TopCards = ({
  totalOrganizationDetail,
  totalCampaigns,
  TotalEarning,
  totalVendors,
  comparedCounts,
  TotalIps,
}) => {
  // Ensure comparedCounts is properly structured
  const safeComparedCounts = Array.isArray(comparedCounts)
    ? comparedCounts
    : [];

  // Map the counts to the correct positions
  const topCardsData = [
    {
      id: 1,
      icon: <Users />, // Blue
      title: "Total Clients",
      count: totalOrganizationDetail,
      iconBg: "#E3F2FD", // Light blue background
      comparedData: safeComparedCounts[1] || { percentage: 0, arrow: "→" }, // Organizations is index 1
    },
    {
      id: 2,
      icon: <VendorIcon />, // Orange
      title: "Total VPs",
      count: totalVendors,
      iconBg: "#FFF3E0", // Light orange background
      comparedData: safeComparedCounts[3] || { percentage: 0, arrow: "→" }, // Vendors is index 3
    },
    {
      id: 3,
      icon: <IpIcon />, // Red
      title: "Total IPs",
      count: TotalIps,
      iconBg: "#FFEBEE", // Light red background
      comparedData: safeComparedCounts[2] || { percentage: 0, arrow: "→" }, // IPs is index 2
    },
    {
      id: 4,
      icon: <CampaignOutlinedIcon />, // Red
      title: "Total Campaigns",
      count: `${totalCampaigns}`,
      iconBg: "#FFEBEE", // Light red background
      comparedData: safeComparedCounts[0] || { percentage: 0, arrow: "→" }, // Campaigns is index 0
    },
  ];

  return (
    <Grid container spacing={3}>
      {topCardsData?.map((data) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          key={data.id}
          sx={{
            borderRadius: 3,
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              position: "relative",
              borderRadius: 3,
              overflow: "hidden",
              backgroundColor: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              {/* Icon with Background */}
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  backgroundColor: data.iconBg || "#E8F5FE",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                {data.icon}
              </Box>

              {/* Text Content */}
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    color: "var(--heading-color, #333)",
                    marginBottom: "4px",
                  }}
                >
                  {data?.count ? data.count : "0"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "var(--subtext-color, #666)" }}
                >
                  {data?.title}
                </Typography>
              </Box>
            </Stack>

            <Box
              sx={{
                position: "absolute",
                top: 3,
                right: 12,
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: data.comparedData?.arrow === "↓" ? "#F44336" : "#4CAF50", // Red for down, green for up
                fontSize: "12px",
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                Last Month:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {data.comparedData?.percentage || 0}%{" "}
                {data.comparedData?.arrow === "↓" ? (
                  <PolygonDown />
                ) : (
                  <PolygonUp />
                )}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default TopCards;
